module.exports = __webpack_public_path__ + "img/infographics_5.db7458ae.png";